/**
 * Whether the visitor has asked for reduced motion.
 *
 * CSS switches off every animation and transition on its own (see base.css), so
 * this hook exists for the motion CSS cannot reach: the typed-placeholder
 * timer, which is a `setTimeout` loop rather than a keyframe. Running it while
 * the rest of the page is still would be exactly the flicker the preference
 * exists to prevent.
 */

import { useMediaQuery } from './useMediaQuery.js';

export function useReducedMotion(): boolean {
  return useMediaQuery('(prefers-reduced-motion: reduce)');
}
